// Partners shown on the landing — validators + ecosystem partners.
// Used to convey trust without claiming any real affiliation.

export const PARTNERS = [
  { name: "Coinbase",   url: "https://assets.coingecko.com/markets/images/23/large/Coinbase_Coin_Primary.png" },
  { name: "Binance",    url: "https://assets.coingecko.com/markets/images/52/large/binance.jpg" },
  { name: "Kraken",     url: "https://assets.coingecko.com/markets/images/29/large/kraken.jpg" },
  { name: "Jito",       url: "https://assets.coingecko.com/coins/images/33228/large/jto.png" },
  { name: "Lido",       url: "https://assets.coingecko.com/coins/images/13573/large/Lido_DAO.png" },
  { name: "Chainlink",  url: "https://cdn.jsdelivr.net/npm/cryptocurrency-icons@0.18.1/128/color/link.png" },
  { name: "Marinade",   url: "https://assets.coingecko.com/coins/images/17752/large/PSigc4ie_400x400.png" },
  { name: "Rocket Pool",url: "https://cdn.jsdelivr.net/npm/cryptocurrency-icons@0.18.1/128/color/rpl.png" },
  { name: "Pyth",       url: "https://assets.coingecko.com/coins/images/31924/large/pyth.png" },
  { name: "Arbitrum",   url: "https://assets.coingecko.com/coins/images/16547/large/photo_2023-03-29_21.47.00.jpeg" },
  { name: "Optimism",   url: "https://assets.coingecko.com/coins/images/25244/large/Optimism.png" },
  { name: "Polygon",    url: "https://cdn.jsdelivr.net/npm/cryptocurrency-icons@0.18.1/128/color/matic.png" },
];

export const TESTIMONIALS = [
  {
    quote: "Switched 60% of my treasury here. The MEV smoothing pool legitimately adds 2–3 points of yield I wasn't capturing on Lido directly.",
    name: "Mara V.",
    role: "Treasury, on-chain fund",
    avatarColor: "#0055FF",
  },
  {
    quote: "Auto-compounding every 12h means I stopped manually claiming. Fee-saved alone covers the platform cut.",
    name: "Daniel K.",
    role: "Solo validator operator",
    avatarColor: "#9945FF",
  },
  {
    quote: "Honest about lockups, no shady promises. The fact that they break down validator vs priority-fee yield convinced me.",
    name: "Aiko T.",
    role: "DeFi researcher",
    avatarColor: "#14F195",
  },
  {
    quote: "Referral payouts hit my wallet on time, every 24h. Brought 12 friends from Discord — that's real product-market fit.",
    name: "0xLiquid",
    role: "Community lead, NFT DAO",
    avatarColor: "#FF4500",
  },
  {
    quote: "Used to babysit 9 different staking dashboards. Now it's one. Reset my Sunday mornings.",
    name: "Priya S.",
    role: "Crypto-native founder",
    avatarColor: "#FFEA00",
  },
  {
    quote: "The 2.5% insurance vault is what tipped me. Most platforms ignore slashing entirely.",
    name: "Hendrik J.",
    role: "ETH staker since 2020",
    avatarColor: "#00E676",
  },
];
